import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PropTypes from 'prop-types';

import Chip from '@zenbusiness/zui/Chip';

const IconPropsMap = new Map([
  ['pro', { label: 'Pro', color: 'secondary', icon: <RocketLaunchIcon /> }],
  ['premium', { label: 'Premium', color: 'warning', icon: <WorkspacePremiumIcon /> }]
]);

function Plan({ type }) {
  const iconProps = IconPropsMap.get(type);

  return (
    <Chip
      size="sm"
      iconPosition="end"
      {...iconProps}
    />
  );
}

Plan.propTypes = {
  type: PropTypes.oneOf(['pro', 'premium'])
};

export default Plan;
